import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterApoios() {
        return axiosJwt
            .get(`${api}/credenciados/gerentes/apoios`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDisponiveis() {
        return axiosJwt
            .get(`${api}/credenciados/gerentes/apoios/disponiveis`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirApoios(apoios) {
        return axiosJwt
            .post(`${api}/credenciados/gerentes/apoios`, apoios)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirApoios(apoioId) {
        return axiosJwt
            .delete(`${api}/credenciados/gerentes/apoios/${apoioId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }

    // obterPorId(contratacaoId) {
    //     return axiosJwt
    //         .get(`${api}/credenciados/gerentes/contratacoes/${contratacaoId}`)
    //         .then(response => {
    //             return response.data
    //         })
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // }
}
